export default __webpack_public_path__ + "static/media/0x8192759bf7f247cc92f74e39b3a4225516624fc1.9c0d726d.png";